import AboutCompany from './AboutCompany';

export default AboutCompany;
